import { Injectable } from '@angular/core';
import { BehaviorSubject, isObservable, of } from 'rxjs';
import { map } from 'rxjs/operators';

import { NavigationAction, NavigationLink } from './types';

@Injectable({
    providedIn: 'root'
})
export class BrandShopTertiaryNavigationService {
    private _navigationLinks = new BehaviorSubject<NavigationLink[]>([]);
    private _navigationActions = new BehaviorSubject<NavigationAction[]>([]);

    navigationLinks = this._navigationLinks.asObservable();
    navigationActions = this._navigationActions.asObservable().pipe(
        map((actions) =>
            actions.map((action) => ({
                ...action,
                counter: isObservable(action.counter)
                    ? action.counter
                    : typeof action.counter === 'number'
                      ? of(action.counter)
                      : null,
                counterFn: typeof action.counter === 'function' ? action.counter : null
            }))
        )
    );

    removeItems(links = true, actions = true) {
        if (links) {
            this.clearLinks();
        }
        if (actions) {
            this.clearActions();
        }
    }

    setItems(links: NavigationLink[], actions: NavigationAction[]) {
        if (links && links.length) {
            this.setLinks(links);
        }
        if (actions && actions.length) {
            this.setActions(actions);
        }
    }

    private clearActions() {
        this._navigationActions.next([]);
    }

    private clearLinks() {
        this._navigationLinks.next([]);
    }

    private setActions(actions: NavigationAction[]) {
        this._navigationActions.next(actions);
    }

    private setLinks(links: NavigationLink[]) {
        this._navigationLinks.next(links);
    }
}
